import React from 'react'
import Button from 'react-bootstrap/Button'
import { useCallback } from 'react'

const FormCustom = ({ onSubmit, dataSubmit, children, viewSubmit, disablebSubmit, textButton, className, loadSubmit, id }) => {
  const handleSubmit = useCallback(e => {
    e.preventDefault()
    let dataForm = {}

    let hasError = false
    let f = e.target.elements
    for (let i = 0; i < f.length; i++) {
      let ele = f[i]

      if (!ele.validity.valid) {
        ele.focus()
        hasError = true
        break
      }

      if (ele.tagName === 'INPUT') {
        if (ele.name.includes('[]')) {
          if (ele.checked) {
            if (!dataForm[ele.name.replace('[]', '')]) {
              dataForm[ele.name.replace('[]', '')] = [ele.value]
            } else {
              dataForm[ele.name.replace('[]', '')].push(ele.value)
            }
          }
          continue
        }

        if (!dataForm[ele.name]) {
          dataForm[ele.name] = ele.value
        }
      }
      else if (ele.tagName === 'TEXTAREA') {
        if (!dataForm[ele.name]) {
          dataForm[ele.name] = ele.value
        }
      }
      else if (ele.tagName === 'SELECT') {
        if (!dataForm[ele.name]) {
          dataForm[ele.name] = ele.value
        }
      }
    }

    if (!e.target.checkValidity() || hasError) {
      e.target.classList.add('was-validated')
      return
    }

    e.target.classList.remove('was-validated')

    onSubmit({ e, data: dataSubmit })
  }, [onSubmit, dataSubmit])

  return (<form className={'needs-validation row ' + className} noValidate onSubmit={handleSubmit} autoComplete="off" id={id}>
    {children}
    {viewSubmit ? <div className="col-12">
      <Button variant="success" disabled={disablebSubmit || loadSubmit} className="mt-2" block type="submit">
        {loadSubmit ? <i className="fa fa-circle-notch fa-spin text-white"></i> : <><i className="fa fa-check me-2 text-white"></i> <span className='text-white'>{textButton}</span></>}
      </Button>
    </div> : ''}
  </form>)
}
FormCustom.defaultProps = {
  onSubmit: () => { },
  viewSubmit: true,
  data: [],
  disablebSubmit: false,
  textButton: 'Guardar Información',
  className: '',
  loadSubmit: false,
}

export default FormCustom